import { useNavigate } from 'react-router-dom';
import { ArrowRight, Globe } from 'lucide-react';

const MAP_BG = 'https://static.prod-images.emergentagent.com/jobs/0e7ec82b-be21-4167-ae09-299c58207254/images/20bef7cbecd3d91aa84d00d85100cc053b4958b1fb4255cfd4f7f2b7146f0b51.png';

export default function CountryHomePage() {
  const navigate = useNavigate();

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center p-6"
      style={{ backgroundImage: `url(${MAP_BG})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundAttachment: 'fixed' }}
    >
      <div className="bg-white/95 backdrop-blur-md border-4 border-white rounded-3xl shadow-2xl p-8 sm:p-10 max-w-md w-full text-center">
        <div className="w-20 h-20 rounded-full bg-gradient-to-br from-emerald-500 to-teal-600 flex items-center justify-center mx-auto mb-4 shadow-lg border-4 border-white">
          <Globe className="w-10 h-10 text-white" strokeWidth={2.5} />
        </div>

        <h1 className="font-heading text-4xl sm:text-5xl font-black text-gray-900 mb-2">
          Guess the Country!
        </h1>
        <p className="font-body text-base text-gray-600 mb-6 leading-relaxed">
          Read the hint and guess which country it is! Countries from Asia, Europe, Americas, Africa and more!
        </p>

        <div className="flex justify-center gap-3 mb-6">
          <span className="bg-emerald-50 text-emerald-700 text-xs font-bold px-3 py-1.5 rounded-full">
            15 Questions
          </span>
          <span className="bg-emerald-50 text-emerald-700 text-xs font-bold px-3 py-1.5 rounded-full">
            All Continents
          </span>
        </div>

        <button
          data-testid="start-country-quiz"
          onClick={() => navigate('/country-quiz/play')}
          className="bg-gradient-to-r from-emerald-500 to-teal-600 text-white font-black text-xl py-4 px-10 rounded-full border-b-[6px] border-teal-800 active:border-b-0 active:translate-y-[6px] transition-all hover:from-emerald-400 hover:to-teal-500 flex items-center gap-3 mx-auto shadow-lg"
        >
          Explore!
          <ArrowRight className="w-6 h-6" />
        </button>

        <button
          data-testid="country-back-studio"
          onClick={() => navigate('/')}
          className="mt-5 text-gray-500 font-bold text-sm hover:text-gray-800 transition-colors underline"
        >
          Back to Studio
        </button>
      </div>
    </div>
  );
}
